import { TestCaseExecution } from "@features/executions/testcase-execution/domain/interfaces";

export interface TestCaseExecutionStateModel {
	executions: Array<TestCaseExecution>;
}

export const testCaseExecutionsStateDefaults = {
	executions: [],
};
